/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
/** A cell of a PlantSim sweep report's `raw_data` sheet. */
export const plantSimSweepCellSchema = z.union([z.number(), z.string(), z.null()]);
/**
 * Scenarios of a PlantSim v2 sweep (batch) as the engine reports them: one row per scenario of
 * the report's `raw_data` sheet, keyed by its column headers. Inputs are plain columns (e.g.
 * `plant_poi_mw_ac`, `{ess}_duration`), yearly metrics are `{metric}_year_{n}`. `pending` until the
 * report is written; `failed` when the sweep ended without one.
 */
export const plantSimSweepScenariosSchema = z.object({
    status: z.enum(['ready', 'pending', 'failed']),
    columns: z.array(z.string()),
    rows: z.array(z.record(z.string(), plantSimSweepCellSchema)),
});
//# sourceMappingURL=sweep.js.map